
import { useState, useEffect } from 'react';
import { Dialog } from '@/components/ui/dialog';
import { AuthComponent } from '../auth/Auth';
import { WebsiteSection } from './types/section-types';
import { useAuthSession } from '@/hooks/useAuthSession';
import { OgImageUpload } from './OgImageUpload';
import { StandardImageUpload } from './StandardImageUpload';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

interface ImageUploadProps {
  defaultSection?: WebsiteSection;
  defaultSubsection?: string;
}

export const ImageUpload = ({ defaultSection, defaultSubsection }: ImageUploadProps) => {
  const { session, loading } = useAuthSession();
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const navigate = useNavigate();

  // Special case for OG image upload
  const isOgImageUpload = defaultSubsection === 'og-image';

  useEffect(() => {
    if (!loading && !session) {
      // Show login dialog
      setAuthDialogOpen(true);
      toast.warning("Bitte melden Sie sich an, um Bilder hochzuladen.");
    }
  }, [session, loading]);

  const handleCloseAuthDialog = () => {
    setAuthDialogOpen(false);
    // If still not authenticated, go back to home
    if (!session) {
      toast.error("Anmeldung erforderlich. Zurück zur Hauptseite.");
      navigate('/');
    }
  };

  if (loading) {
    return <div className="p-4 text-center">Laden...</div>;
  }

  if (!session) {
    return (
      <Dialog open={authDialogOpen} onOpenChange={setAuthDialogOpen}>
        <AuthComponent open={authDialogOpen} onOpenChange={handleCloseAuthDialog} />
      </Dialog>
    );
  }

  // Choose the appropriate upload component based on the type
  return (
    <>
      {isOgImageUpload ? (
        <OgImageUpload />
      ) : (
        <StandardImageUpload 
          defaultSection={defaultSection} 
          defaultSubsection={defaultSubsection} 
        />
      )}
    </>
  );
};
